import React from "react"
import * as styles from "./index.module.scss"
import { CustomLink } from "@/components"
import { formatDate } from "@/utils"

const MediaReportsCard: React.FC<AboutUsMediaReports> = ({
  title,
  date,
  logo,
  link,
}) => {
  return (
    <div className={styles.companyNewsCard}>
      <CustomLink linkTo={link}>
        <div className={styles.left}>
          <h4>{title}</h4>
          <div className={styles.author}>{formatDate(date)}</div>
        </div>
        <figure className={styles.right}>
          <img src={logo.media.url} alt={logo.alt} />
        </figure>
      </CustomLink>
    </div>
  )
}

export default MediaReportsCard
